<ul class="layout-menu" *ngIf="!isLoading">

    <p-button icon="pi pi-database" (onClick)="op2.toggle($event)" [rounded]="true" label="{{ currentCompany.name }}"
        severity="primary" size="medium" class="mt-2 w-full inline-block pointer-events-none curstor-default" styleClass="w-full" *ngIf="currentCompany">
    </p-button>
    <ng-container *ngFor="let item of dashboardItems; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
    <ng-container *ngFor="let item of organisationItems; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
    <ng-container *ngFor="let item of inputItems; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
    <ng-container *ngFor="let item of searchItems; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
    <ng-container *ngFor="let item of outputItems; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
    <ng-container *ngFor="let item of adminItems; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>

<div class="flex h-full" style="align-items: center; justify-content: center;" *ngIf="isLoading">
    <p-progress-spinner strokeWidth="4" [style]="{ width: '50px', height: '50px' }"></p-progress-spinner>
</div>